import { createAction, props } from '@ngrx/store';

import { TechnicalResult } from '../../models/technical-result.model';

export const loadTechnicalResultRequest = createAction(
  '[TechnicalResult] Load technical result for date',
  props<{ startDate: string; endDate: string }>(),
);

export const loadTechnicalResultSuccess = createAction(
  '[TechnicalResult] Load technical result succeeded',
  props<{ technicalResult: TechnicalResult }>(),
);
